import type { ButtonHTMLAttributes, ReactNode } from "react";

import { SpinnerIcon } from "./icons";

type Variant = "primary" | "secondary" | "ghost";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  /** Shows a spinner and blocks clicks — prevents double submits. */
  loading?: boolean;
  icon?: ReactNode;
};

const variants: Record<Variant, string> = {
  primary:
    "bg-primary-container text-on-primary shadow-glow-primary hover:bg-primary disabled:bg-surface-container-highest disabled:text-outline disabled:shadow-none",
  secondary:
    "border border-outline-variant bg-surface-container-high text-on-surface hover:bg-surface-container-highest disabled:text-outline",
  ghost: "text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface disabled:text-outline",
};

export function Button({
  variant = "primary",
  loading = false,
  icon,
  disabled,
  className = "",
  children,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl px-5 text-label-lg uppercase transition disabled:cursor-not-allowed ${variants[variant]} ${className}`}
      {...props}
    >
      {loading ? <SpinnerIcon /> : null}
      {children}
      {!loading && icon ? icon : null}
    </button>
  );
}